/*
 * Copyright (C) 2014 Spanning Cloud Apps. LLC  All rights reserved.
 */
import './basicpicker.user.tpl.html';

angular
  .module('shared.basicpicker', [])
  /**
   * Controller for the BasicPicker template.
   */
  .controller('BasicPickerCtrl', function ($scope, $injector, NG_DATE_FORMATS, KEY_CODES) {
    var pickerStore = $scope.storeName;
    // set the dt value for the calendar.
    $scope.dt = pickerStore.date;
    $scope.format = NG_DATE_FORMATS.SHORT;

    // forced to surround with quotes here so disable jshint rule.
    /* jshint -W109 */
    $scope.dateOptions = {
      'year-format': "'yy'",
      'starting-day': 1,
      'show-button-bar': false,
      'day-format': "'d'",
      maxMode: "'day'"
    };

    // TODO angular-bootstrap 0.10.0 does not support min-date
    //if (pickerStore.minDate) {
    //  $scope.dateOptions['min-date'] = pickerStore.minDate;
    //}

    // TODO angular-bootstrap 0.10.0 does not support max-date
    //if (pickerStore.maxDate) {
    //  $scope.dateOptions['max-date'] = pickerStore.maxDate;
    //}
    /* jshint +W109 */

    /**
     * Handler to open the calendar popup when clicking on the dropdown button.
     */
    $scope.open = function ($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.opened = true;
    };

    /**
     * Handler that is fired when a new date is selected.
     */
    $scope.dateChanged = function () {
      pickerStore.date = $scope.dt;
      pickerStore.selectDate = $scope.dt;
    };

    /**
     * Handler to close the calendar popup when pressing enter key.
     */
    $scope.close = function ($event) {
      if ($event.keyCode === KEY_CODES.ENTER && $scope.opened) {
        $scope.opened = false;
      }
    };

    // Watch for changes to the picker store
    $scope.$watch(
      function () {
        return pickerStore.date;
      },
      function (newVal) {
        if (!_.isEqual(newVal, $scope.dt)) {
          $scope.dt = newVal;
        }
      }
    );
  })
  .run(function ($templateCache) {
    // Taken from ui-bootstrap-tpls.js
    // Override the bootstrap popup template for the date picker in order to customize it for our needs.
    // Replaces the button at the bottom of the calendar with custom "Get Latest Backup"
    $templateCache.put(
      'template/datepicker/popup.html',
      '<ul class="dropdown-menu sbsf-bulk-restore-datepicker" ng-if="isOpen" style="display: block" ng-style="{display: (isOpen && \'block\')}" ng-keydown="keydown($event)" ng-click="$event.stopPropagation()">\n' +
        ' <li ng-transclude></li>\n' +
        ' <li class="sbsf-batch-picker-button-bar" ng-if="showButtonBar" style="padding:10px 9px 2px">\n' +
        '  <button type="button" class="btn btn-sbsf sbsf-batch-picker-latest-btn" ng-click="$parent.$parent.$parent.getLatest()">{{ $parent.$parent.$parent.getLatestLabel() }}</button>\n' +
        ' </li>\n' +
        '</ul>\n' +
        ''
    );

    // Custom template to use our own date picker icons (left & right arrow next to the date) and our own disabled date formatting.
    $templateCache.put(
      'template/datepicker/day.html',
      '<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n' +
        '  <thead>\n' +
        '    <tr>\n' +
        '      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><div class="sbsf-batch-picker-arrow sbsf-arrow-left"></div></button></th>\n' +
        '      <th colspan="{{::5 + showWeeks}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n' +
        '      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><div class="sbsf-batch-picker-arrow sbsf-arrow-right"></div></button></th>\n' +
        '    </tr>\n' +
        '    <tr>\n' +
        '      <th ng-if="showWeeks" class="text-center"></th>\n' +
        '      <th ng-repeat="label in ::labels track by $index" class="text-center"><small aria-label="{{::label.full}}">{{::label.abbr}}</small></th>\n' +
        '    </tr>\n' +
        '  </thead>\n' +
        '  <tbody>\n' +
        '    <tr ng-repeat="row in rows track by $index">\n' +
        '      <td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>\n' +
        '      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n' +
        '        <button type="button" style="min-width:100%;" class="btn btn-default btn-sm" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="{\'muted\': dt.secondary}">{{::dt.label}}</span></button>\n' +
        '      </td>\n' +
        '    </tr>\n' +
        '  </tbody>\n' +
        '</table>\n' +
        ''
    );
  })
  /**
   * The directive for the basic picker view. The storeName attribute should be
   * the name of the Store factory implementation to provide data to the picker.
   */
  .directive('basicpicker', function () {
    return {
      templateUrl: 'shared/basicpicker/basicpicker.user.tpl.html',
      scope: {
        storeName: '='
      },
      controller: 'BasicPickerCtrl'
    };
  });
